import { roundToScale } from './roundToScale'

type Input = Parameters<typeof roundToScale>[0]

export const roundBillingQuantity = <T extends Input>(value: T) => roundToScale(value, 4)
